import { useContext } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useTradeInfo } from '~/contexts/FinanceAndTradeContext';
import InventoryContext from '~/contexts/InventoryContext';

export default function useDataForAnalytics() {
  const { appliedFilters, sortBy } = useContext(AppliedFiltersContext);
  const {
    inventory: {
      data: {
        searchRequestId,
        inventory: {
          pagination: { currentPage, totalMatchedInventory },
          vehicles
        },
        userDeliveryInfo
      }
    }
  } = useContext(InventoryContext);
  const tradeInfo = useTradeInfo();

  return {
    appliedFilters,
    currentPage,
    isDefaultFilters: Object.keys(appliedFilters)?.length === 0,
    searchRequestId,
    sortBy,
    totalMatchedInventory,
    tradeInfo,
    userDeliveryInfo,
    vehicles
  };
}
